import { useQuery as RQuseQuery } from '@tanstack/react-query';
import * as deepmerge from 'deepmerge';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { useGlobalConfig } from './GlobalClientConfigProvider';
const EMPTY_KEY = [''];
/** React hook to make a query */
const useQuery = (requester, config) => {
    const { isTest, ...globalConfig } = useGlobalConfig();
    /** This is to avoid overriding global error handling (but can be used for other fields of the config) */
    const deepMergedConfig = deepmerge.all([
        requester?.cacheConfig || {},
        config || {}
    ]);
    let aMockedResponse = undefined;
    if (!isNil(requester) && 'data' in requester) {
        aMockedResponse = requester.data;
    }
    const mockedResponse = useMemo(() => ({
        isLoading: false,
        data: aMockedResponse,
        error: null,
        dataUpdatedAt: Date.now(),
        errorUpdateCount: 0,
        errorUpdatedAt: Date.now(),
        failureCount: 0,
        failureReason: null,
        fetchStatus: 'idle',
        isError: false,
        isFetched: true,
        isFetchedAfterMount: true,
        isFetching: false,
        isLoadingError: false,
        isPaused: false,
        isPending: false,
        isPlaceholderData: false,
        isRefetchError: false,
        isRefetching: false,
        isStale: false,
        isSuccess: true,
        isInitialLoading: false,
        refetch: (async () => { }),
        status: 'success'
    }), [aMockedResponse]);
    const result = isTest
        ? mockedResponse
        : RQuseQuery({
            ...globalConfig,
            ...deepMergedConfig,
            queryKey: requester?.key ?? EMPTY_KEY,
            queryFn: () => {
                if (!isNil(requester)) {
                    return requester.request();
                }
                else {
                    throw new Error('try to execute empty requester');
                }
            }
        });
    return result;
};
export default useQuery;
